(function() {
    'use strict';

    angular.module('jotApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$state', '$stateParams'];

    function HealthModalController ($state, $stateParams) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = $stateParams.currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function cancel() {
            // $uibModalInstance.dismiss('cancel');
        }
    }
})();
